import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=5ba3b516&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"
import style0 from "./Apps.vue?vue&type=style&index=0&id=5ba3b516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3b516",
  null
  
)

export default component.exports